import React, { useMemo, useState } from 'react';
import RiskConfidenceBadge from './RiskConfidenceBadge';
import RiskScopeBadge from './RiskScopeBadge';
import SupportingSignalsDrawer from './SupportingSignalsDrawer';

const severityClass = (severity) => {
  const key = String(severity || '').toUpperCase();
  if (key === 'CRITICAL') return 'text-red-300';
  if (key === 'HIGH') return 'text-amber-300';
  if (key === 'MEDIUM') return 'text-blue-300';
  return 'text-emerald-300';
};

const PredictiveRiskTable = ({ risks }) => {
  const [selectedRisk, setSelectedRisk] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const rows = useMemo(() => risks || [], [risks]);

  const openSignals = (risk) => {
    setSelectedRisk(risk);
    setDrawerOpen(true);
  };

  return (
    <>
      <div className="rounded-xl border border-slate-800 bg-slate-900/70 p-4">
        <div className="mb-3 text-sm font-semibold text-slate-200">Daftar Risiko Prediktif</div>
        <div className="overflow-x-auto">
          <table className="min-w-full text-left text-sm">
            <thead className="bg-slate-950/80 text-xs uppercase tracking-wide text-slate-400">
              <tr>
                <th className="px-3 py-2">Waktu</th>
                <th className="px-3 py-2">Tipe Risiko</th>
                <th className="px-3 py-2">Scope</th>
                <th className="px-3 py-2">Area/Segmen</th>
                <th className="px-3 py-2">Severity</th>
                <th className="px-3 py-2">Confidence</th>
                <th className="px-3 py-2">Estimasi Terdampak</th>
                <th className="px-3 py-2">Rekomendasi</th>
                <th className="px-3 py-2">Aksi</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((risk) => (
                <tr key={risk.riskId} className="border-b border-slate-800/80 align-top">
                  <td className="px-3 py-2 text-xs text-slate-400">{risk.updatedAt ? new Date(risk.updatedAt).toLocaleString('id-ID') : '-'}</td>
                  <td className="px-3 py-2 text-slate-200">{risk.riskType}</td>
                  <td className="px-3 py-2"><RiskScopeBadge scopeType={risk.scopeType} scopeKey={risk.scopeKey} /></td>
                  <td className="px-3 py-2 text-slate-300">{risk.areaName || `${risk.oltName || '-'} ${risk.ponPort || ''}`.trim()}</td>
                  <td className={`px-3 py-2 font-semibold ${severityClass(risk.severity)}`}>{risk.severity}</td>
                  <td className="px-3 py-2"><RiskConfidenceBadge confidence={risk.confidence} /></td>
                  <td className="px-3 py-2 text-slate-200">{risk.affectedCustomerEstimate || 0}</td>
                  <td className="max-w-xs px-3 py-2 text-xs text-slate-300">{risk.recommendedAction}</td>
                  <td className="px-3 py-2">
                    <button
                      type="button"
                      onClick={() => openSignals(risk)}
                      className="rounded-md border border-slate-700 px-2 py-1 text-xs text-slate-200 hover:bg-slate-800"
                    >
                      Lihat Signals
                    </button>
                  </td>
                </tr>
              ))}
              {rows.length === 0 ? (
                <tr>
                  <td className="px-3 py-4 text-sm text-slate-400" colSpan={9}>
                    Tidak ada risiko sesuai filter.
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>

      <SupportingSignalsDrawer open={drawerOpen} risk={selectedRisk} onClose={() => setDrawerOpen(false)} />
    </>
  );
};

export default PredictiveRiskTable;
